export interface IImageryRenderingRule {
  [id: string]: string
}
export interface ILandsatLayerResult {
  objectid: number;
  acquisitiondate: number;
  cloudcover: number | null;
  pr: number;
  shape?: __esri.Geometry;
}

export interface ISentinelLayerResult {
  objectid: number;
  acquisitiondate: number;
  cloudcover: number | null;
  tilename: string;
  shape?: __esri.Geometry;
}

export interface ILayerObject {
  type: string;
  options: {
    visible: boolean;
    id: string;
    group?: string;
    subgroup?: string | null;
    title: string;
    url: string;
    portalUrl: string;
    includeInDropdowns: boolean;
    sublayers?: Array<{ id: number; visible: boolean, popupTemplate?: { title: string; content: string };
  }>;
    compressionQuality?: number;
    renderingRule?: any;
    outFields?: Array<string>;
    optionalQueryLayer?: string;
    popupTemplate?: { title: string; content: string };
    popupEnabled?: boolean;
    pixelType?: string,
    timeInfo?:{
      startField: string;
      interval?: {
        value: number;
        unit: string;
      }
      fullTimeExtent?: {
        start: Date;
        end: Date;
      },
    },
    timeExtent?: {
      start: null | Date;
      end: Date;
    },
    useViewTime?: boolean;
  };
  renderingRules?: Array<string>
}

export interface IRasterFunctionInfo {
  description: string;
  help: string;
  name: string;
}

export interface IAuditAreaResults {
  landsatResults: Array<ILandsatLayerResult>;
  sentinelResults: Array<ISentinelLayerResult>;
}

export interface IRasterImageryLayer extends __esri.ImageryLayer {
  threshold: Array<number>;
  minValue: number;
  maxValue: number;
}

export interface IPixelData {
  extent: __esri.Extent;
  pixelBlock: any;
}

export enum ESentinelProperties {
  acquisitionDate = 'acquisitiondate',
  cloudCover = 'cloudcover',
  gridLabel = 'tilename',
}

export enum ELandsatProperties {
  acquisitionDate = 'acquisitiondate',
  cloudCover = 'cloudcover',
  gridLabel = 'pr',
}

export enum ERasterAnalysis {
  EVI = 'EVI',
  NDVI = 'NDVI',
  GNDVI = 'GNDVI',
  SAVI = 'SAVI',
}
